import {IImportService} from "./IImportService";
import {BaseService} from "./BaseService";
import { StateService } from "@uirouter/angularjs";
import { MqttClient } from "../entities/MqttClient";

export class MqttClientService extends BaseService<MqttClient>{
    static $inject = ['$http','$q','$state'];
    constructor($http: ng.IHttpService, $q: ng.IQService, $state: StateService) {
        super($http, $q, $state, MqttClient);
    }
    protected getBaseUrl():string{
        return "mqttclient";
    }
    generateSecret():ng.IPromise<string> {
        var config:any = {};
        return this.useGetHandler(this.getBaseUrl(),"secret", config);
    }

}
